// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2XMH_","footer":"ModalUpdate_footer__2W2rv"};